import * as D from '@/utils/dbmodel';

export default {
    namespaced: true,
    state: {
        list: [], //table中的list显示数据
        pagination: {}, //分页相关的信息
        record: {},

    },
    getters: {
    },
    mutations: {
        save (state, action) {
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
        }
    },
    actions: {

        // 查询磐石导出记录
        queryexportrecord (context, payload) {
            return D.select({
                ...payload
            })
        },

        // 查询磐石导出记录
        queryimportrecord (context, payload) {
            return D.select({
                ...payload
            })
        },
        queryPlatformPage (context, payload) {
            return D.select({
                ...payload
            })
        },
        queryPlatformList (context, payload) {
            return D.select({
                ...payload
            })
        },
        detailPlatformPage (context, payload) {
            return D.select({
                ...payload
            })
        },
        delPlatformPage (context, payload) {
            return D.del({
                ...payload
            })
        },
        editPlatformPage (context, payload) {
            return D.select({
                ...payload
            })
        },
        addPlatformPage (context, payload) {
            return D.select({
                ...payload
            })
        },



        //通用-Export
        //查询
        querycommonexportconfig (context, payload) {
            return D.select({
                ...payload
            })
        },
        // 详情
        detailcommonexportconfig (context, payload) {
            return D.select({
                ...payload
            })
        },

        // 新增
        addcommonexportconfig (context, payload) {
            return D.select({
                ...payload
            })
        },

        // 编辑
        updatecommonexportconfig (context, payload) {
            return D.select({
                ...payload
            })
        },

        // 删除
        deletecommonexportconfig (context, payload) {
            return D.select({
                ...payload
            })
        },

        //common-Import
        querycommonimportconfig (context, payload) {
            return D.select({
                ...payload
            })

        },
        // 详情
        detailcommonimportconfig (context, payload) {
            return D.select({
                ...payload
            })
        },

        // 新增
        addcommonimportconfig (context, payload) {
            return D.select({
                ...payload
            })
        },

        // 编辑
        updatecommonimportconfig (context, payload) {
            return D.select({
                ...payload
            })
        },

        // 删除
        deletecommonimportconfig (context, payload) {
            return D.select({
                ...payload
            })
        },
        osslist (context, payload) {
            return D.select({
                ...payload
            })
        },
        ossdel (context, payload) {
            return D.del({
                ...payload
            })
        },
        osskey (context, payload) {
            return D.select({
                ...payload
            })
        },
        ossplatformlist (context, payload) {
            return D.select({
                ...payload
            })
        },

        exportQueryDiff (context, payload) {
            return D.select({
                ...payload
            })
        },
        importQueryDiff (context, payload) {
            return D.select({
                ...payload
            })
        },

        exportConfigTransfer (context, payload) {
            return D.edit({
                ...payload
            })
        },

        importConfigTransfer (context, payload) {
            return D.edit({
                ...payload
            })
        },

    }
}
